import { Badge } from '@payaca/ambrosia';
import { FC, useMemo, type JSX } from 'react';

import { getInvoicePLBadgeState } from '@payaca/helpers/invoiceHelper';
import { ReadableInvoiceStatus } from '@payaca/types/invoiceTypes';
import { PrelineColourVariant } from '@payaca/types/preline';

type Props = {
  status: ReadableInvoiceStatus;
};

const InvoiceStatusBadge: FC<Props> = ({ status }: Props): JSX.Element => {
  const badgeColour = useMemo<PrelineColourVariant>(
    () => getInvoicePLBadgeState(status),
    [status]
  );

  return (
    <Badge variant="soft" colour={badgeColour}>
      {status}
    </Badge>
  );
};

export default InvoiceStatusBadge;
